import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import Select from '../../../Components/select/select';
import TextField from "../../../Components/textField/textField";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css"

export default class altDepartment extends React.Component {
  state = {
    departments: [],
    departmentids: [],
    description: "",
    id: 0,
    code: null,
    show: false,
    message: "",
    factorys: [],
    factorysAllProps: [],
    readOnly: true,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };
  componentDidMount = () => {
    Api.get("/departments/").then((resp) => {
      this.setState({ departmentids: [...resp.data] });
    });
    Api.get("/factorys/").then((resp) => {
      let factorys = [];
      resp.data.forEach((element) => {
        factorys.push({ value: element.id, label:element.description });
      });
      this.setState({
        factorys: factorys,
        factorysAllProps: [...resp.data],
      });
    });
  };

  SelectedDepartment = (childData) => {
    const { id, description, code } = this.state.departmentids.find(
      (value) => value.id === childData
    );
    this.setState({ id: id, description: description, code: code , readOnly: false});
  };

  SelectFactory = (childData) => {
    const { id } = this.state.factorysAllProps.find(
      (v) => v.id === childData
    );
    let arrDeparts = [...this.state.departmentids];
    let result = arrDeparts.filter((e) => e.id_factory === id);
    let arraDeps = [];
    result.forEach(el => {arraDeps.push({ value:el.id, label:el.description })})
    this.setState({ departments: arraDeps });
  };

  sendData = async (id) => {
    if (this.state.id !== 0 && (this.state.code !== null && this.state.code !== "") && (this.state.description !== null && this.state.description !== "")) {
      await Api.put(`/departments/${id}`, {
        code: this.state.code,
        description: this.state.description,
      })
        .then(() => {
          this.setState({notification: true, notification_message: "Setor alterado com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((error) => {
          if (error.response) {

            if(error.response.status == 400){
              this.setState({ show: true, message: "Erro ao editar departamento, verifique se os dados foram preenchidos corretamente." })
            }
          }
        });
    } else {
      this.setState({ show: true, message: "Necessário selecionar o setor." });
    }
  };

  changeValueDescription = (value) => {
    this.setState({ description: value });
  };
  changeValueCode = (value) => {
    this.setState({ code: value });
  };
  callbackfunction = () => {
    this.setState({ show: false });
  };

  handleKeys = (e) => {
    if (document.getElementById("n1")) {
      let x = document.getElementById("n1");
      let vallen = x.value.length;
      if (
        (e.which != 8 && e.which != 46 && e.which != 0 && e.which < 48) ||
        e.which > 57 ||
        e.key == "."
      ) {
        e.preventDefault();
      }
    }
  };

  render() {
    let { show, message, notification, notification_message, notification_type } = this.state;
    return (
      <div className="box">
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        <div className="input_fields_alt_depart form">
        <h4>Alterar Setor</h4>
          {show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
            />
          ) : null}
          <div className="inputs">
            <div className='select1AltDepart element'>
              <Select
                autoSelect={true}
                label="Selecionar Planta"
                arrData={this.state.factorys}
                handleSelect={this.SelectFactory}
              />
            </div>
            <div className='select2AltDepart element'>
              <Select
                autoSelect={false}
                label="Selecionar Setor"
                arrData={this.state.departments}
                handleSelect={this.SelectedDepartment}
              />
            </div>
            <div className='element'><TextField section="false" title="Código" name="code" max={5} parentCallback={this.changeValueCode} value={this.state.code} altType={true} validationType="int" readOnly={this.state.readOnly}/></div>
            <div className='element'><TextField section="false" title="Descrição" name="description" max={30} parentCallback={this.changeValueDescription} value={this.state.description} altType={true} validationType="varchar" readOnly={this.state.readOnly}/></div>
          </div>
          <div className='btnAltDepart submitButton'>
            <Button
              title="Alterar"
              parentCallback={() => this.sendData(this.state.id)}
            />
          </div>
        </div>
      </div>
    );
  }
}